import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons/faStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  rating: number | undefined;
  count?: number;
  className?: string;
};

// API rating is a 0-100 percent; render five whole/half/empty stars matching
// Angular's rating-stars directive.
const ratingToStars = (rating: number | undefined): number => {
  if (!rating || rating <= 0) return 0;
  const clamped = Math.min(rating, 100);
  return Math.round(clamped / 10) / 2;
};

export const RatingStars = ({ rating, count, className }: Props): JSX.Element => {
  const value = ratingToStars(rating);
  return (
    <span className={`inline-flex items-center gap-0.5 text-amber-500 text-sm ${className ?? ''}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <FontAwesomeIcon key={i} icon={i <= value ? faStar : faStarRegular} />
      ))}
      {typeof count === 'number' && <span className='text-neutral-700 ml-1'>({count})</span>}
    </span>
  );
};
